import Body from "../components/Body.jsx";

const Home = () => (
  <div className="main-content">
    <Body />
  </div>
);

export default Home;
